import React  from 'react'
import CreditMemoRequestItem from '../../../Domain/CreditMemo/CreditMemoRequestItem';
import ShowEntityData from '../../../Elements/ShowEntityData';
import CreditMemoRequestService from '../../../Services/CreditMemo/CreditMemoRequestService';

export default class CreditMemoRequestDetailsInfoTab extends React.Component 
{
    static defaultProps={

    };

    constructor(props) 
    {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);

        this.state = {
            creditMemoRequestId:urlParams.get('id'),
            loading:true
        };
    }

    componentDidMount() 
    {
        
    }

    

    render()
    {
        return (
          <ShowEntityData
            itemId={this.state.creditMemoRequestId}
            entityName='Credit Memo Request Details'
            type={CreditMemoRequestItem}
            serviceGetByIdFunction={CreditMemoRequestService.GetById}
          />
        );
    }
}

